import { Component, Input, OnInit, Output, OnChanges, SimpleChanges, EventEmitter, ViewChild, AfterViewInit, ElementRef, ViewContainerRef, TemplateRef } from '@angular/core';
import { MapMarker } from '@angular/google-maps';
import { PollutionForecastTypes } from '../../models/app-constants';
import { BeachSite } from '../../models/BeachSite';
import { MenuContextualService } from 'src/app/shared/MenuContextualService';
import { SitePopupInfoModel } from 'src/app/models/SiteDetails/SitePopupInfoModel';
import { SitesService } from 'src/app/services/sites.service';
import { MARKER_ICON_SIZE } from "../../models/app-constants";

// export type SiteMarkerClickEvent = { siteId : string, 
// 				mapMarker : MapMarker, 
// 				marker : google.maps.Marker,
// 				position? : google.maps.LatLng | null, 
// 				markerElementRef? : ElementRef | null | undefined,  
// 				anchorPoint : google.maps.Point | null | undefined,
// 				event? : MouseEvent};

export type SiteMarkerClickEvent = { 
	siteId : string;
	mapMarker : MapMarker;
	marker : google.maps.Marker;
	event? : MouseEvent
};

@Component({
	selector: 'app-site-marker',
	templateUrl: './site-marker.component.html',
	styleUrls: ['./site-marker.component.scss'],
})
export class SiteMarkerComponent implements OnInit, AfterViewInit, OnChanges {
	@Input() site: BeachSite;
	@Output() markerClickedEvent = new EventEmitter<SiteMarkerClickEvent>();
	@ViewChild(MapMarker) markerComponent : MapMarker;
	@ViewChild("markerElementRef", { read : ElementRef }) markerElementRef : ElementRef;
	@ViewChild("markerElementRef") marker: any;	
	
	private ICON_WIDTH = 32;
	private ICON_HEIGHT = 32;

	public markerOptions: google.maps.MarkerOptions = {
		draggable: false,
		//animation: google.maps.Animation.DROP,
		clickable: true,
		//collisionBehavior : google.maps.CollisionBehavior.OPTIONAL_AND_HIDES_LOWER_PRIORITY	// collision behavior available in beta
	};
	
	public markerPosition: google.maps.LatLng;
	private markerIcon: google.maps.Icon;	

	constructor() 
	{

	}	

	ngOnInit() {		
		this.createMarker();
	}

	ngAfterViewInit(): void {
		
	}

	ngOnChanges(changes: SimpleChanges): void {
		
	}

	private createMarker = () => {
		this.markerPosition = new google.maps.LatLng(
			this.site.Lat, this.site.Lng
		);
		let imgUrl  = "";
		const size = new google.maps.Size(MARKER_ICON_SIZE.ICON_WIDTH, MARKER_ICON_SIZE.ICON_HEIGHT);
		const origin = new google.maps.Point(0, 0);
		const anchor = new google.maps.Point(MARKER_ICON_SIZE.ICON_WIDTH / 2, MARKER_ICON_SIZE.ICON_HEIGHT / 2); // new google.maps.Point(this.ICON_WIDTH, this.ICON_HEIGHT)
		
		switch (this.site.PollutionForecast) {

		case PollutionForecastTypes.POLLUTION_UNLIKELY:
			imgUrl = 'assets/images/WaterqualityForecastIndicator/Green-32.svg';			
			break;
		case PollutionForecastTypes.POLLUTION_POSSIBLE:
			imgUrl = 'assets/images/WaterqualityForecastIndicator/Yellow-32.svg';			
			break;
		case PollutionForecastTypes.POLLUTION_LIKELY:
			imgUrl = 'assets/images/WaterqualityForecastIndicator/Red-32.svg';			
			break;
		default:
			imgUrl = 'assets/images/WaterqualityForecastIndicator/Unavailable-32.svg';			
			break;
		}		
		this.markerIcon = {
			url: imgUrl,
			alt : this.site?.SiteName,
			anchor : anchor,
			size : size,
			origin : origin
		} as google.maps.Icon;

		this.markerOptions = {
			...this.markerOptions,
			title : `${this.site?.SiteName} (${this.site?.Lat},${this.site?.Lng})`,
			//label: { text : this.site.siteId.toString() || "", color : "white" },
			icon : this.markerIcon		
		};		
	}

	onMarkerClick(event : any, mapMarker : MapMarker, markerElement : any) 
	{			
		if(mapMarker && mapMarker.marker)
		{
			this.markerClickedEvent.emit(
			{ 
				siteId : this.site.Identifier, 
				mapMarker : mapMarker,
				marker : mapMarker.marker,			
				event : event 
			});
		}
	}

	get siteMapMarker() : { siteId : string, 
		mapMarker : MapMarker, 		
		position? : google.maps.LatLng | null | undefined, 
		markerElementRef? : ElementRef | undefined}  
	{		
		return { 
			siteId : this.site.Identifier, 			
			mapMarker : this.markerComponent, 
			position : this.markerComponent?.marker?.getPosition(),
			markerElementRef : this.markerElementRef
		};
	}	
}
